export default "__VITE_ASSET__Bpr2I19g__"